/**
 * Footer — ported from `Foyer_Dashboard_CURRENT.jsx` lines 10084-10094.
 */

import { useC } from '../../lib/theme.js';

const monoFont = "'JetBrains Mono', monospace";
const serifFont = "'Instrument Serif', serif";
const sansFont = "'Geist', sans-serif";

export function Footer(): JSX.Element {
  const C = useC();
  return (
    <footer
      className="px-4 sm:px-6 py-8 mt-12"
      style={{ borderTop: `1px solid ${C.borderSoft}` }}
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <span style={{ fontFamily: serifFont, fontSize: 16, color: C.text }}>Sill</span>
        </div>
        <div
          className="flex items-center gap-4"
          style={{ fontFamily: sansFont, fontSize: 12, color: C.muted }}
        >
          <FooterLink href="https://status.sill.so">Status</FooterLink>
          <FooterLink href="https://docs.sill.so">Docs</FooterLink>
          <FooterLink href="https://sill.so/privacy">Privacy</FooterLink>
          <FooterLink href="https://sill.so/terms">Terms</FooterLink>
        </div>
      </div>
    </footer>
  );
}

function FooterLink({ href, children }: { href: string; children: string }): JSX.Element {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: 'inherit', textDecoration: 'none' }}
      onMouseEnter={(e) => { e.currentTarget.style.textDecoration = 'underline'; }}
      onMouseLeave={(e) => { e.currentTarget.style.textDecoration = 'none'; }}
    >
      {children}
    </a>
  );
}
